<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="center">{{ $t('sections.customer.section.personalInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <!-- Prefix -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.prefix') }}*</label>
                <v-select :clearable="true" :options="prefixOptions" :name="$t('sections.customer.dataForm.prefix')" :reduce="res => res.value" v-model="form.prefix" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Name -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.name") }}*</label>
                <vs-input type="text" class="w-full" v-model="form.name" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Surname -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.customer.dataForm.surname')}}*</label>
                <vs-input type="text" class="w-full" v-model="form.surname" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.birthDay')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.birthDay') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.birthDay"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.idCardNumber')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.idCardNumber') }}*</label>
                <vs-input type="text" class="w-full"  v-model="form.idCardNumber"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.issueDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.issueDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.issueDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.expDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.expDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.expDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.occupation')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.occupation') }}</label>
                <vs-input type="text" v-model="form.career" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.position')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.position') }}</label>
                <vs-input type="text" v-model="form.position" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.affiliate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.affiliate') }}</label>
                <vs-input type="text" v-model="form.affiliate" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.project')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.project') }}*</label>
                <v-select v-model="form.project" :clearable="true" :options="projectOptions" :name="$t('sections.customer.dataForm.project')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.campus')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.campus') }}*</label>
                <v-select v-model="form.campus" :clearable="true" :options="filteredCampusOptions" :name="$t('sections.customer.dataForm.campus')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.studentCode')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.studentCode') }}*</label>
                <vs-input type="text" v-model="form.studentCode" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap ">
            <div class="vx-col w-full sm:w-1/2 md:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.degree')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.degree') }}*</label>
                <v-select v-model="form.degree" :clearable="true" :options="degreeOptions" :name="$t('sections.customer.dataForm.degree')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full sm:w-1/2 md:w-1/4">
              <validation-provider name="ปีการศึกษา" rules="required|periodTermYear" v-slot="{ errors }">
                <label class="vs-input--label">ปีการศึกษา*</label>
                <vs-input type="text" v-model="form.period" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <validation-provider :name="$t('sections.customer.dataForm.curriculum')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.faculty') }}/{{ $t('sections.customer.dataForm.curriculum') }}*</label>
                <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" :name="$t('sections.customer.dataForm.curriculum')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="center">{{ $t('sections.customer.section.contactInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.location')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.location') }}</label>
                <vs-input type="text" v-model="form.address.location" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.moo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alley" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.road" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="store" v-model="form.address.subDistrict" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="store" v-model="form.address.district" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="store" v-model="form.address.province" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="store" v-model="form.address.zipcode" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.locationDoc')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.locationDoc') }}</label>
                <vs-input type="text" v-model="form.address.locationDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumberDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.mooDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alleyDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.roadDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="storeDoc" v-model="form.address.subDistrictDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="storeDoc" v-model="form.address.districtDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="storeDoc" v-model="form.address.provinceDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="storeDoc" v-model="form.address.zipcodeDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.phone')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.phone') }}</label>
                <vs-input type="text" v-model="form.phone" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.mobile')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.mobile') }}*</label>
                <vs-input type="text" v-model="form.mobile" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.email')" rules="required|email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.email') }}*</label>
                <vs-input type="text" v-model="form.email" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full flex flex-col sm:flex-row sm:justify-end">
              <vs-button class="btn mt-2 sm:mt-0 sm:ml-4 sm:mr-4 w-full sm:w-auto" @click="submit">{{ $t("sections.customer.dataForm.action.btnSave") }}</vs-button>
              <vs-button class="btn mt-2 sm:mt-0 w-full sm:w-auto" type="border" color="warning" @click="reset">{{ $t("sections.customer.dataForm.action.btnReset") }}</vs-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import { DataStore } from 'vue-thailand-address';

const {mapActions: mapCustomerActions, mapState: mapCustomerFields } = createNamespacedHelpers('Customer')
const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        birthDay: '',
        idCardNumber: '',
        issueDate: '',
        expDate: '',
        career: '',
        position: '',
        affiliate: '',
        studentCode: '',
        project: '',
        campus: '',
        degree: '',
        period: '',
        periodTerm: '',
        periodYear: 0,
        curriculum: '',
        address: {
          id: '',
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
          locationDoc: '',
          houseNumberDoc: '',
          mooDoc: '',
          alleyDoc: '',
          roadDoc: '',
          subDistrictDoc: '',
          districtDoc: '',
          provinceDoc: '',
          zipcodeDoc: ''
        },
        phone: '',
        mobile: '',
        email: '',
        isExternal: false,
        status: 'Enabled'
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      store: new DataStore(),
      storeDoc: new DataStore(),
    }
  },
  computed: {
    ...mapCustomerFields(['status', 'borrower']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      projectOptions :'Master/projectOptions',
      campusOptions :'Master/campusOptions',
      degreeOptions :'Master/degreeOptions',
      facultyCurriculumOptions :'Master/facultyCurriculumOptions',
      statusesOptions :'Master/statusesOptions',
    }),
    filteredCampusOptions() {
      // Filter campuses based on selected project
      return this.campusOptions.filter(campus => campus.projectId === this.form.project);
    }
  },
  methods: {
    ...mapCustomerActions(['initializing', 'getBorrower', 'updateBorrower']),
    ...mapMasterActions(['getPrefixOptions', 'getProjectOptions', 'getCampusOptions', 'getDegreeOptions', 'getCurriculumOptions']),
    async loadOptions() {
      const vm = this
      const { getPrefixOptions, getProjectOptions, getDegreeOptions, getCurriculumOptions, getCampusOptions } = vm
      if(vm.prefixOptions.length === 0) await getPrefixOptions()
      if(vm.projectOptions.length === 0) await getProjectOptions()
      if(vm.campusOptions.length === 0) await getCampusOptions()
      if(vm.degreeOptions.length === 0) await getDegreeOptions()
      if(vm.facultyCurriculumOptions.length === 0) await getCurriculumOptions()
    },
    async initData() {
      const vm = this;
      const { getBorrower } = vm
      await getBorrower({form: {id: vm.$route.params.id}})
      const { borrower } = vm
      const prefix = (borrower.prefix ? borrower.prefix.id : '')
      const project = (borrower.project ? borrower.project.id : '')
      const campus = (borrower.campus ? borrower.campus.id : '')
      const degree = (borrower.degree ? borrower.degree.id : '')
      const curriculum = (borrower.curriculum ? borrower.curriculum.id : '')

      vm.form = {
        prefix,
        name: borrower.name,
        surname: borrower.surname,
        birthDay: borrower.birthDay ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.birthDay) : '',
        idCardNumber: borrower.idCardNumber,
        issueDate: borrower.issueDate ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.issueDate) : '',
        expDate: borrower.expDate ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.expDate) : '',
        career: borrower.career,
        position: borrower.position,
        affiliate: borrower.affiliate,
        studentCode: borrower.studentCode,
        project,
        campus,
        degree,
        period: `${borrower.periodTerm}/${borrower.periodYear}`,
        periodTerm: borrower.periodTerm,
        periodYear: borrower.periodYear,
        curriculum,
        address: {
          location: borrower.address.location,
          houseNumber: borrower.address.houseNumber,
          moo: borrower.address.moo,
          alley: borrower.address.alley,
          road: borrower.address.road,
          subDistrict: borrower.address.subDistrict,
          district: borrower.address.district,
          province: borrower.address.province,
          zipcode: borrower.address.zipcode,
          locationDoc: borrower.address.locationDoc,
          houseNumberDoc: borrower.address.houseNumberDoc,
          mooDoc: borrower.address.mooDoc,
          alleyDoc: borrower.address.alleyDoc,
          roadDoc: borrower.address.roadDoc,
          subDistrictDoc: borrower.address.subDistrictDoc,
          districtDoc: borrower.address.districtDoc,
          provinceDoc: borrower.address.provinceDoc,
          zipcodeDoc: borrower.address.zipcodeDoc
        },
        phone: borrower.phone,
        mobile: borrower.mobile,
        email: borrower.email,
        isExternal: borrower.isExternal,
        status: borrower.status
      }
    },
    async submit () {
      const vm = this
      const { updateBorrower } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        updateBorrower({
          id: vm.$route.params.id,
          form: {
            prefix: {id: vm.form.prefix || ''},
            name: vm.form.name,
            surname: vm.form.surname,
            birthDay: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.birthDay),
            idCardNumber: vm.form.idCardNumber,
            issueDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.issueDate),
            expDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.expDate),
            career: vm.form.career,
            position: vm.form.position,
            affiliate: vm.form.affiliate,
            studentCode: vm.form.studentCode,
            project: {id: vm.form.project || ''},
            campus: {id: vm.form.campus || ''},
            degree: {id: vm.form.degree || ''},
            periodTerm: vm.form.period.split('/')[0].toString(),
            periodYear: parseInt(vm.form.period.split('/')[1]),
            curriculum: {id: vm.form.curriculum || ''},
            address: {
              location: vm.form.address.location,
              houseNumber: vm.form.address.houseNumber,
              moo: vm.form.address.moo,
              alley: vm.form.address.alley,
              road: vm.form.address.road,
              subDistrict: vm.form.address.subDistrict,
              district: vm.form.address.district,
              province: vm.form.address.province,
              zipcode: vm.form.address.zipcode,
              locationDoc: vm.form.address.locationDoc,
              houseNumberDoc: vm.form.address.houseNumberDoc,
              mooDoc: vm.form.address.mooDoc,
              alleyDoc: vm.form.address.alleyDoc,
              roadDoc: vm.form.address.roadDoc,
              subDistrictDoc: vm.form.address.subDistrictDoc,
              districtDoc: vm.form.address.districtDoc,
              provinceDoc: vm.form.address.provinceDoc,
              zipcodeDoc: vm.form.address.zipcodeDoc
            },
            phone: vm.form.phone,
            mobile: vm.form.mobile,
            email: vm.form.email,
            isExternal: vm.form.isExternal,
            status: vm.form.status
          },
          vm
        })
      })
    },
    reset () {
      const vm = this
      vm.initData();
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    'form.project': {
      handler(newValue, oldValue) {
        if(oldValue !== ''){
          this.form.campus = null; // Reset campus when project changes
        }
      },
      immediate: true, // Optional: run the watcher immediately
    },
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
}
</script>

<style scoped>
.vx-col {
  padding-top: 10px;
}

</style>
